"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowInstanceAccessor = exports.FlowInstancesAccessor = exports.FlowAccessor = exports.FlowsAccessor = void 0;
const flow_runs_1 = require("../flow-runs");
const iframe_1 = require("../iframe");
const accessors_1 = require("../accessors");
const flow_runs_2 = require("../flow-runs");
const MAX_POLLING_ERRORS = 10;
class FlowsAccessor extends accessors_1.ElementListAccessor {
    constructor(client) {
        super(client, 'flows');
    }
}
exports.FlowsAccessor = FlowsAccessor;
class FlowAccessor extends accessors_1.ElementAccessor {
    constructor(client, idOrKey) {
        super({
            client,
            path: 'flows',
            idOrKey,
        });
    }
}
exports.FlowAccessor = FlowAccessor;
class FlowInstancesAccessor extends accessors_1.ElementInstanceListAccessor {
    constructor(client) {
        super(client, 'flow-instances');
    }
}
exports.FlowInstancesAccessor = FlowInstancesAccessor;
class FlowInstanceAccessor extends accessors_1.ElementInstanceAccessor {
    constructor(client, selector) {
        super({
            client,
            selector,
            instancePath: 'flow-instance',
        });
        this.client = client;
        this.selector = selector;
    }
    async enable() {
        return this.patch({ enabled: true });
    }
    async disable() {
        return this.patch({ enabled: false });
    }
    async updateToLatestFlow() {
        const id = await this.getId();
        return this.client.post(`/flow-instances/${id}/update-to-latest-flow`);
    }
    async setup() {
        const id = await this.getId();
        return this.client.post(`/flow-instances/${id}/setup`);
    }
    async reset() {
        const id = await this.getId();
        return this.client.post(`/flow-instances/${id}/reset`);
    }
    async openConfiguration(options = {
        showPoweredBy: true,
    }) {
        var _a;
        const id = await this.getId();
        const uri = this.client.getEmbedUri(`/flow-instances/${id}/configuration`, {
            nodeKey: options.nodeKey,
            showPoweredBy: (_a = options.showPoweredBy) !== null && _a !== void 0 ? _a : true,
        });
        return (0, iframe_1.openIframe)(uri, {
            onClose: options.onClose,
        });
    }
    async startRun(options = {}) {
        const id = await this.getId();
        const flowRunsAccessor = new flow_runs_2.FlowRunsAccessor(this.client);
        const flowRun = await flowRunsAccessor.create({
            flowInstanceId: id,
            nodeKey: options.nodeKey,
            input: options.input,
        });
        return flowRun;
    }
    async run(options = {}) {
        function onUpdate(flowRun) {
            options.onUpdate && options.onUpdate(flowRun);
        }
        const flowRun = await this.startRun(options);
        onUpdate(flowRun);
        let checkFlowRunInterval;
        function cleanup() {
            checkFlowRunInterval && clearInterval(checkFlowRunInterval);
        }
        return new Promise((resolve, reject) => {
            const handleFlowRunUpdate = async (flowRun) => {
                var _a, _b;
                onUpdate(flowRun);
                if (flowRun.state === flow_runs_1.FlowRunState.COMPLETED) {
                    cleanup();
                    resolve(flowRun);
                }
                else if (flowRun.state === flow_runs_1.FlowRunState.FAILED) {
                    cleanup();
                    reject(new Error(`Flow run ${flowRun.id} failed: ${(_b = (_a = flowRun.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.message}`));
                }
            };
            const fetchFlowRun = async () => {
                const flowRunAccessor = new flow_runs_2.FlowRunAccessor(this.client, flowRun.id);
                await handleFlowRunUpdate(await flowRunAccessor.get());
            };
            let pollingFlowRun = false;
            let errors = 0;
            checkFlowRunInterval = setInterval(async () => {
                if (!pollingFlowRun) {
                    pollingFlowRun = true;
                    try {
                        await fetchFlowRun();
                        errors = 0;
                    }
                    finally {
                        errors += 1;
                        if (errors > MAX_POLLING_ERRORS) {
                            cleanup();
                            reject(new Error(`Got ${errors} errors while polling flow run ${flowRun.id} state - aborting`));
                        }
                        pollingFlowRun = false;
                    }
                }
            }, 1000);
        });
    }
}
exports.FlowInstanceAccessor = FlowInstanceAccessor;
//# sourceMappingURL=accessors.js.map